module.exports = __webpack_public_path__ + "img/ios-user.ba5e907a.png";